import { NgModule, Component } from '@angular/core';
import { RouterModule,Routes } from '@angular/router';
import { ClientInfoComponent } from './component/client-info/client-info.component';
import { PropertyInfoComponent } from './component/property-info/property-info.component';
import { PropertyDetailsComponent } from './component/property-details/property-details.component';
import { SchedulingComponent } from './component/scheduling/scheduling.component';
import { InspectionInfoComponent } from './component/inspection-info/inspection-info.component';
import { FindingsComponent } from './component/findings/findings.component';
import { DiagramComponent } from './component/diagram/diagram.component';
import { ConfirmInspectionComponent } from './component/confirm-inspection/confirm-inspection.component'
import { JobInfoComponent } from './component/job-info/job-info.component'
import { CompletionTasksComponent } from './component/completion-tasks/completion-tasks.component'
import { OverviewComponent } from './component/overview/overview.component'
import { InspectionReportsComponent } from './component/inspection-reports/inspection-reports.component'
import { InspectionLogsComponent } from './component/inspection-logs/inspection-logs.component';
import { AuthGuard } from '../../extras/auth.guard';
import { IntakeAccessGuard } from './intake-access.service';

// Logged-in users only, like the app's other pages. data.access: which users may open the page
// (IntakeAccessService - twin-ci's roles and status-bar permissions).
const intakeRoutes : Routes = [{ path: '', canActivate: [AuthGuard], children: [
  { path:'inspections-order-parties', component: ClientInfoComponent, canActivate: [IntakeAccessGuard], data: { access: 'intake' } },
  { path:'inspections-order-parties/:jobId', component: ClientInfoComponent, canActivate: [IntakeAccessGuard], data: { access: 'intake' } },
  { path:'inspections-edit-property', component: PropertyInfoComponent, canActivate: [IntakeAccessGuard], data: { access: 'intake' } },
  { path:'inspections-edit-property/:jobId', component: PropertyInfoComponent, canActivate: [IntakeAccessGuard], data: { access: 'intake' } },
  { path:'inspections-order-property2/:jobId', component: PropertyDetailsComponent, canActivate: [IntakeAccessGuard], data: { access: 'intake' } },
  { path:'inspections-schedule', component: SchedulingComponent, canActivate: [IntakeAccessGuard], data: { access: 'intake' } },
  { path:'inspections-schedule/:jobId', component: SchedulingComponent, canActivate: [IntakeAccessGuard], data: { access: 'intake' } },
  { path:'inspections-profile/:jobId', component: InspectionInfoComponent, canActivate: [IntakeAccessGuard], data: { access: 'profile' } },
  { path:'inspections-profile-findings/:jobId', component: FindingsComponent, canActivate: [IntakeAccessGuard], data: { access: 'profile' } },
  { path:'inspections-profile-diagram/:jobId', component: DiagramComponent, canActivate: [IntakeAccessGuard], data: { access: 'profile' } },
  { path:'inspections-profile-review/:jobId', component: ConfirmInspectionComponent, canActivate: [IntakeAccessGuard], data: { access: 'profile' } },
  { path:'inspections-job/:jobId', component: JobInfoComponent, canActivate: [IntakeAccessGuard], data: { access: 'work' } },
  { path:'inspections-job-completion/:jobId', component: CompletionTasksComponent, canActivate: [IntakeAccessGuard], data: { access: 'work' } },
  // Confirm is now the Review section of Completion Tasks; old links land there.
  { path:'inspections-job-review/:jobId', redirectTo: 'inspections-job-completion/:jobId' },
  { path:'inspections-completed-sheet/:jobId', component: OverviewComponent, canActivate: [IntakeAccessGuard], data: { access: 'overview' } },
  // Document Manager (moved from twin-ci inspections_reports 2026-11-04). Every role has it, as in
  // twin-ci; the API checks the role and, for inspectors, that the job is theirs. twin-ci's
  // inspections_reports pages redirect here.
  { path:'inspections-reports/:jobId', component: InspectionReportsComponent },
  // Log History (was twin-ci Administrator::logs). 'logs' is what url/logs maps to via app_urls.
  { path:'logs/:jobId', component: InspectionLogsComponent, canActivate: [IntakeAccessGuard], data: { access: 'logs' } },
]}];  

@NgModule({
  imports: [
    RouterModule.forRoot(intakeRoutes)
  ],
  exports: [ RouterModule ],
  declarations: []
})

export class IntakeRoutingModule { }
